if (!customElements.get('quick-order-list')) {
  customElements.define(
    'quick-order-list',
    class QuickOrderList extends BulkAdd {
      constructor() {
        super();
        this.cart = document.querySelector('cart-drawer');
        this.quickOrderListId = `${this.dataset.section}-${this.dataset.productId}`;
        this.defineInputsAndQuickOrderTable();

        this.variantItemStatusElement = document.getElementById('shopping-cart-variant-item-status');
        const form = this.querySelector('form');
        this.inputFieldHeight = this.querySelector('.variant-item__quantity-wrapper')?.offsetHeight || 0;
        this.isListInsideModal = document.querySelector('.quick-add-bulk');
        this.stickyHeaderElement = document.querySelector('sticky-header');
        this.getTableHead();
        this.getTotalBar();

        if (this.stickyHeaderElement) {
          this.stickyHeader = {
            height: this.stickyHeaderElement.offsetHeight,
            type: `${this.stickyHeaderElement.getAttribute('data-sticky-type')}`,
          };
        }

        if (this.getTotalBar()) {
          this.totalBarPosition = window.innerHeight - this.getTotalBar().offsetHeight;

          window.addEventListener('resize', () => {
            this.totalBarPosition = window.innerHeight - this.getTotalBar().offsetHeight;
            this.stickyHeader.height = this.stickyHeaderElement ? this.stickyHeaderElement.offsetHeight : 0;
          });
        }

        const pageParams = new URLSearchParams(window.location.search);
        window.pageNumber = decodeURIComponent(pageParams.get('page') || '');

        form.addEventListener('submit', this.onSubmit.bind(this));
        this.addMultipleDebounce();
      }

      defineInputsAndQuickOrderTable() {
        this.inputs = this.querySelectorAll('.variant-item__input');
        this.table = this.querySelector('.quick-order-list__table');

        this.inputs.forEach(input => {
          input.removeEventListener('input', this.onInputChange);
          input.addEventListener('input', this.onInputChange.bind(this));
        });

        this.updateTotals();
      }

      getTotalBar() {
        return this.querySelector('.quick-order-list__total-bar');
      }

      getTableHead() {
        return this.querySelector('thead');
      }

      updateTotals() {
        let totalQuantity = 0;
        let totalPrice = 0;

        this.inputs.forEach(input => {
          const quantity = parseInt(input.value) || 0;
          const priceElement = input.closest('tr')?.querySelector('[data-variant-price]');
          const price = priceElement ? parseFloat(priceElement.dataset.variantPrice) : 0;

          totalQuantity += quantity;
          totalPrice += quantity * price;
        });

        const quantityOutput = document.getElementById('quick-order-total-quantity');
        const priceOutput = document.getElementById('quick-order-total-price');

        if (quantityOutput) quantityOutput.textContent = totalQuantity;
        if (priceOutput) priceOutput.textContent = `$${totalPrice.toFixed(2)}`;
      }

      onInputChange() {
        this.updateTotals();
      }
    }
  );
}

// FUNCIONALIDAD DE AGRUPACIÓN POR COLOR Y EXPANSIÓN
document.addEventListener('DOMContentLoaded', function () {
  const headers = document.querySelectorAll('.variant-color-header');

  headers.forEach(header => {
    header.addEventListener('click', () => {
      const groupId = header.dataset.groupId;
      const group = document.getElementById(groupId);
      if (!group) return;

      const isVisible = group.style.display === 'table-row-group';
      group.style.display = isVisible ? 'none' : 'table-row-group';

      const arrow = header.querySelector('.toggle-arrow');
      if (arrow) arrow.innerText = isVisible ? '▼' : '▲';

      const quickOrderList = document.querySelector('quick-order-list');
      if (quickOrderList && typeof quickOrderList.defineInputsAndQuickOrderTable === 'function') {
        quickOrderList.defineInputsAndQuickOrderTable();
      }
    });
  });
});
